import { CrossIcon } from '@shared/assets/icons';
import { UnstyledButton } from '@shared/ui/unstyled-button';
import * as stylex from '@stylexjs/stylex';
import { useId } from 'react';
import { styles } from './styles';

interface InputWithClearProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  onClear: () => void;
  placeholder?: string;
  error?: string | false;
  iconSize?: string;
  iconColor?: string;
  iconFillOpacity?: string;
}

export const InputWithClear: React.FC<InputWithClearProps> = ({
  label,
  value,
  onChange,
  onClear,
  placeholder,
  error,
  iconSize = '16',
  iconColor,
}) => {
  const id = useId();
  const hasError = Boolean(error);
  const inputStyles = hasError ? styles.inputError : undefined;

  return (
    <div {...stylex.props(styles.input)}>
      <label {...stylex.props(styles.label)} htmlFor={id}>
        {label}
      </label>
      <div {...stylex.props(styles.inputWrapper)}>
        <input
          id={id}
          {...stylex.props(styles.inputField, inputStyles)}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
        {value && (
          <UnstyledButton onClick={onClear} {...stylex.props(styles.clearButton)}>
            <CrossIcon width={iconSize} height={iconSize} color={iconColor} />
          </UnstyledButton>
        )}
      </div>
      {error && <span {...stylex.props(styles.errorMessage)}>{error}</span>}
    </div>
  );
};
